import React from "react";
import PropTypes from "prop-types";
import { Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const DEFAULT_POPOVER_STYLES = {
  root: { width: 320, maxWidth: "calc(100vw - 32px)" },
  body: { whiteSpace: "normal" }
};

const stopLabelClick = event => {
  event.preventDefault();
  event.stopPropagation();
};

const mergePopoverStyles = styles => {
  if (!styles) return DEFAULT_POPOVER_STYLES;

  return {
    ...DEFAULT_POPOVER_STYLES,
    ...styles,
    root: {
      ...DEFAULT_POPOVER_STYLES.root,
      ...styles.root
    },
    body: {
      ...DEFAULT_POPOVER_STYLES.body,
      ...styles.body
    }
  };
};

const FormItemLabelWithHelp = ({
  label,
  title,
  content,
  placement = "rightBottom",
  trigger = "hover",
  styles,
  getPopupContainer,
  iconStyle = { cursor: "pointer" }
}) => {
  const popoverStyles = mergePopoverStyles(styles);

  return (
    <span>
      {label ? (
        <>
          {label}
          {" "}
        </>
      ) : null}
      <Popover
        placement={placement}
        title={title}
        content={content}
        trigger={trigger}
        styles={popoverStyles}
        getPopupContainer={getPopupContainer}
      >
        <span onMouseDown={stopLabelClick} onClick={stopLabelClick}>
          <QuestionCircleOutlined style={iconStyle} />
        </span>
      </Popover>
    </span>
  );
};

FormItemLabelWithHelp.propTypes = {
  label: PropTypes.node,
  title: PropTypes.node,
  content: PropTypes.node,
  placement: PropTypes.string,
  trigger: PropTypes.string,
  styles: PropTypes.object,
  getPopupContainer: PropTypes.func,
  iconStyle: PropTypes.object
};

export default FormItemLabelWithHelp;